import { LotSearch, GetLotResult, GetStampingByLotNoResult, StampingSearch, ToolingSearch, GetToolingNoByPlatingResult, MFGDateSearch, GetMFGDateByLotNoResult, GetPlatingByStampingResult, PlatingSearch, ItemSearch, ItemDescSearch, ItemModelSearch, GetItemDescListResult, GetItemModelListResult } from './../model/item.model';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { Item, UOM } from "../model/item.model";
import { SelectItem, Attachment } from "../model/common.model";
import { User } from '../model/user.model';

const API_URL = environment.apiUrl;

const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class ItemService {
    private Url = '';  // URL to web api
    currentUser: User;

    constructor(
        private http: HttpClient) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        // console.log(this.currentUser);
        this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/item';

    }

    getItems(): Observable<Item[]> {
        return this.http.get<Item[]>(this.Url, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetItemListSearch(search: ItemSearch): Observable<Item[]> {
        return this.http.post<Item[]>(this.Url + '/list/', search, httpOptions)
            .pipe(
                tap(response => {
                })
            );
    }

    GetItemForExport(search: ItemSearch, type: number): Observable<any> {

        return this.http.post(this.Url + '/GetItemForExport/' + type, search, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',

            }),
            responseType: 'arraybuffer'
        }).pipe(tap((x) => {
        }),
            catchError(this.handleError<ItemSearch>('SearchWorkPermit'))
        );
    }

    getItemsDetailByItemID(itemId: number): Observable<Item> {
        return this.http.get<Item>(this.Url + '/' + itemId, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched GetItemDetailByID`);
                })
            );
    }

    getUomListByItemID(itemId: number): Observable<UOM[]> {
        return this.http.get<UOM[]>(this.Url + '/itemuom/' + itemId, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched GetItemDetailByID`);
                })
            );
    }

    GetUOMList(): Observable<UOM[]> {
        return this.http.get<UOM[]>(this.Url + '/GetUOMList', httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched GetItemDetailByID`);
                })
            );
    }

    getItemTypeList(): Observable<SelectItem[]> {
        return this.http.get<SelectItem[]>(this.Url + '/itemtype/', httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched GetItemDetailByID`);
                })
            );
    }

    getLotByItem(search: LotSearch): Observable<GetLotResult[]> {
        return this.http.post<GetLotResult[]>(this.Url + '/lot/', search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched GetItemDetailByID`);
                })
            );
    }

    GetStampingByLotNo(search: StampingSearch): Observable<GetStampingByLotNoResult[]> {
        return this.http.post<GetStampingByLotNoResult[]>(this.Url + '/stamping/', search, httpOptions)
            .pipe(
                tap(response => {
                })
            );
    }

    GetPlatingByStamping(search: PlatingSearch): Observable<GetPlatingByStampingResult[]> {
        return this.http.post<GetPlatingByStampingResult[]>(this.Url + '/plating/', search, httpOptions)
            .pipe(
                tap(response => {
                })
            );
    }

    GetToolingNoByPlating(search: ToolingSearch): Observable<GetToolingNoByPlatingResult[]> {
        return this.http.post<GetToolingNoByPlatingResult[]>(this.Url + '/tooling/', search, httpOptions)
            .pipe(
                tap(response => {
                })
            );
    }

    GetMFGDateByLotNo(search: MFGDateSearch): Observable<GetMFGDateByLotNoResult[]> {
        return this.http.post<GetMFGDateByLotNoResult[]>(this.Url + '/MFGDate/', search, httpOptions)
            .pipe(
                tap(response => {
                })
            );
    }

    GetItemDescList(search: ItemDescSearch): Observable<GetItemDescListResult[]> {
        return this.http.post<GetItemDescListResult[]>(this.Url + '/GetItemDescList', search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetItemModelList(search: ItemModelSearch): Observable<GetItemModelListResult[]> {
        return this.http.post<GetItemModelListResult[]>(this.Url + '/ItemModelList', search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    getItemCategoryList(): Observable<SelectItem[]> {
        return this.http.get<SelectItem[]>(this.Url + '/itemcategory/', httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched GetItemDetailByID`);
                })
            );
    }
    getItemsCat(): Observable<any[]> {
        return this.http.get<any[]>(this.Url + '/itemcategory/', httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    updateItem(item: Item): Observable<any> {
        console.log('updateItem : ', item);
        const url = `${this.Url}/${item.ItemID}`;
        console.log(url);
        // const httpOptions = {
        //     headers: new HttpHeaders(
        //         {
        //             'Content-Type': 'application/json',
        //             'Authorization': (this.currentUser && this.currentUser.token) ? 'Bearer ' + this.currentUser.token : ''
        //         }
        //     )
        // };
        return this.http.put(url, item, httpOptions).pipe(
            tap(_ => this.log(`updated id=${item.ItemID}`)),
            catchError(this.handleError<any>('updated'))
        );
    }

    addItem(item: Item): Observable<any> {
        // const httpOptions = {
        //     headers: new HttpHeaders(
        //         {
        //             'Content-Type': 'application/json',
        //             'Authorization': (this.currentUser && this.currentUser.token) ? 'Bearer ' + this.currentUser.token : ''
        //         }
        //     )
        // };
        return this.http.post<Item>(this.Url, item, httpOptions).pipe(
            tap((res: any) => this.log(`added  w/ id=${res.Data}`)),
            catchError(this.handleError<any>('Add'))
        );
    }

    uploadItemImage(id: number, data: FormData) {
        // const httpOptions = {
        //     headers: new HttpHeaders(
        //         {
        //             // 'Content-Type': 'application/json',
        //             'Authorization': (this.currentUser && this.currentUser.token) ? 'Bearer ' + this.currentUser.token : ''
        //         }
        //     )
        // };
        return this.http.post(this.Url + '/' + id.toString() + "/uploadImage", data).pipe(
            tap((res: any) => this.log(res)),
            catchError(this.handleError<any>('uploadError'))
        );
    }

    deleteItemImage(id: number) {
        return this.http.post(this.Url + '/' + id.toString() + "/deleteImage", null, httpOptions).pipe(
            tap((res: any) => this.log(res)),
            catchError(this.handleError<any>('deleteImage'))
        );
    }




    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    /** Log a ScgCompanyService message with the MessageService */
    private log(message: string) {
        console.log(message);
        // this.messageService.add('ScgCompanyService: ' + message);
    }


}


// WEBPACK FOOTER //
// ./src/app/services/item.service.ts